<template>
  <main
    :class="`home-page fade-in-fwd ${
      isMenuOpen ? 'isMenuOpenPadding' : 'isMenuClosePadding'
    }`"
    class="min-w-0 max-w-full"
  >
    <div
      class="w-full min-w-0 max-w-full flex flex-col gap-2 py-4 md:py-4 md:px-4"
    >
      <div
        class="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm min-w-0 max-w-full overflow-hidden"
      >
        <div
          class="flex items-center justify-between mb-4 pb-3 border-b border-slate-100"
        >
          <div class="flex items-center gap-2">
            <i class="fa-solid fa-table-cells text-emerald-600"></i>
            <h3 class="font-bold text-slate-800 text-lg m-0">
              Live Casino Extractions
            </h3>
          </div>
          <span
            class="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-emerald-100 text-emerald-700"
          >
            <span
              class="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"
            ></span>
            Realtime Extractions
          </span>
        </div>

        <RoundFinder
          :customColumns="extractionColumns"
          :customFilters="extractionFilters"
          :modalComponent="LiveCasinoRoundModal"
          endpointProps="multipliers/"
          resourceNameProps="extractions"
          defaultSortField="created_at"
          :defaultSortOrder="-1"
        />
      </div>
    </div>
  </main>
</template>

<script setup>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import RoundFinder from "@/slot/components/round/RoundFinder.vue";
import LiveCasinoRoundModal from "../components/LiveCasinoRoundModal.vue";

const store = useStore();
const isMenuOpen = computed(() => store.state.isMenuOpen);

const extractionColumns = ref([
  {
    slug: "multiplier",
    label: "Extracted Number",
    type: "chip",
    sortable: true,
  },
  {
    slug: "roundId",
    label: "Round ID",
    sortable: true,
  },
  {
    slug: "created_at",
    label: "Start Time",
    type: "date",
    sortable: true,
  },
  {
    slug: "end_at",
    label: "End Time",
    type: "date",
    sortable: true,
  },
  {
    slug: "updated_at",
    label: "Updated At",
    type: "date",
    sortable: true,
  },
  {
    type: "action_button",
    label: "Action",
    slug: "actions",
  },
]);

const extractionFilters = ref([
  {
    label: "Round ID",
    type: "text",
    placeholder: "Search for Round ID",
    property: "round_id",
  },
  {
    label: "Start Date",
    isDateTime: true,
    placeholder: "From Start Date",
    property: "start_date",
  },
  {
    label: "End Date",
    isDateTime: true,
    placeholder: "To End Date",
    property: "end_date",
  },
]);
</script>

<style scoped></style>
